const IMPORTED_ID_KEYS = [
  'id',
  'created_at',
  'updated_at',
  'flow',
  'flow_id',
  'step',
  'step_id',
];

export function stripImportedIds(entity = {}) {
  const rest = { ...entity };
  IMPORTED_ID_KEYS.forEach((key) => {
    delete rest[key];
  });
  return rest;
}
